/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.19.1.0 (NJsonSchema v9.10.72.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const FS_API_BASE_URL = new InjectionToken<string>('FS_API_BASE_URL');

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = (key: string, value: any) => key ? value : value.result || value;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(FS_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "/";
    }

    /**
     * Gets all uploaded files
     * @return Success
     */
    filesGet(): Observable<SubmissionMetadata[]> {
        let url_ = this.baseUrl + "/api/files";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesGet(<any>response_);
                } catch (e) {
                    return <Observable<SubmissionMetadata[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SubmissionMetadata[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilesGet(response: HttpResponseBase): Observable<SubmissionMetadata[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SubmissionMetadata.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmissionMetadata[]>(<any>null);
    }

    /**
     * Uploads a file with transactions
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Success
     */
    filesPost(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any | null | undefined, length: number | null | undefined, name: string | null | undefined, fileName: string | null | undefined): Observable<MappingRequiredResponse> {
        let url_ = this.baseUrl + "/api/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            content_.append("Headers", headers.toString());
        if (length !== null && length !== undefined)
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesPost(<any>response_);
                } catch (e) {
                    return <Observable<MappingRequiredResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MappingRequiredResponse>><any>_observableThrow(response_);
        }));
    }

    protected processFilesPost(response: HttpResponseBase): Observable<MappingRequiredResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MappingRequiredResponse.fromJS(resultData200) : new MappingRequiredResponse();
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResult.fromJS(resultData400) : new BadRequestResult();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MappingRequiredResponse>(<any>null);
    }

    /**
     * @param submissionId (optional) 
     * @param hasHeader (optional) 
     * @param headerRowNumber (optional) 
     * @return Success
     */
    filesMappingHeadersGet(submissionId: string | null | undefined, hasHeader: boolean | null | undefined, headerRowNumber: number | null | undefined): Observable<MappingHeadersResponse> {
        let url_ = this.baseUrl + "/api/files/mappingHeaders?";
        if (submissionId !== undefined)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&"; 
        if (hasHeader !== undefined)
            url_ += "hasHeader=" + encodeURIComponent("" + hasHeader) + "&"; 
        if (headerRowNumber !== undefined)
            url_ += "headerRowNumber=" + encodeURIComponent("" + headerRowNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesMappingHeadersGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesMappingHeadersGet(<any>response_);
                } catch (e) {
                    return <Observable<MappingHeadersResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<MappingHeadersResponse>><any>_observableThrow(response_);
        }));
    }

    protected processFilesMappingHeadersGet(response: HttpResponseBase): Observable<MappingHeadersResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? MappingHeadersResponse.fromJS(resultData200) : new MappingHeadersResponse();
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResult.fromJS(resultData400) : new BadRequestResult();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MappingHeadersResponse>(<any>null);
    }

    /**
     * @return Success
     */
    filesBySubmissionIdDelete(submissionId: string): Observable<void> {
        let url_ = this.baseUrl + "/api/files/{submissionId}";
        if (submissionId === undefined || submissionId === null)
            throw new Error("The parameter 'submissionId' must be defined.");
        url_ = url_.replace("{submissionId}", encodeURIComponent("" + submissionId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesBySubmissionIdDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesBySubmissionIdDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processFilesBySubmissionIdDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Applies mapping to submitted file
     * @param submissionId (optional) Id of started submission
     * @param hasHeader (optional) 
     * @param headerRowNumber (optional) 
     * @param mapping (optional) 
     * @return Success
     */
    filesMappingPost(submissionId: string | null | undefined, hasHeader: boolean | null | undefined, headerRowNumber: number | null | undefined, mapping: Mapping[] | null | undefined): Observable<NoContentResult> {
        let url_ = this.baseUrl + "/api/files/mapping?";
        if (submissionId !== undefined)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&"; 
        if (hasHeader !== undefined)
            url_ += "hasHeader=" + encodeURIComponent("" + hasHeader) + "&"; 
        if (headerRowNumber !== undefined)
            url_ += "headerRowNumber=" + encodeURIComponent("" + headerRowNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mapping);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesMappingPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesMappingPost(<any>response_);
                } catch (e) {
                    return <Observable<NoContentResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoContentResult>><any>_observableThrow(response_);
        }));
    }

    protected processFilesMappingPost(response: HttpResponseBase): Observable<NoContentResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NoContentResult.fromJS(resultData200) : new NoContentResult();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoContentResult>(<any>null);
    }

    /**
     * Gets download token for uploaded file by id
     * @return Success
     */
    filesByIdGet(id: string): Observable<TokenResult> {
        let url_ = this.baseUrl + "/api/files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesByIdGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesByIdGet(<any>response_);
                } catch (e) {
                    return <Observable<TokenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenResult>><any>_observableThrow(response_);
        }));
    }

    protected processFilesByIdGet(response: HttpResponseBase): Observable<TokenResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TokenResult.fromJS(resultData200) : new TokenResult();
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResult.fromJS(resultData404) : new NotFoundResult();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenResult>(<any>null);
    }

    /**
     * Gets list of allowed file extensions
     * @return Success
     */
    filesAllowedExtensionsGet(): Observable<ValidationSettings> {
        let url_ = this.baseUrl + "/api/files/allowed-extensions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesAllowedExtensionsGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesAllowedExtensionsGet(<any>response_);
                } catch (e) {
                    return <Observable<ValidationSettings>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidationSettings>><any>_observableThrow(response_);
        }));
    }

    protected processFilesAllowedExtensionsGet(response: HttpResponseBase): Observable<ValidationSettings> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ValidationSettings.fromJS(resultData200) : new ValidationSettings();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidationSettings>(<any>null);
    }

    /**
     * Download file by token
     * @param token (optional) download token
     * @return Success
     */
    filesDownloadGet(token: string | null | undefined): Observable<FileResult> {
        let url_ = this.baseUrl + "/api/files/download?";
        if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilesDownloadGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilesDownloadGet(<any>response_);
                } catch (e) {
                    return <Observable<FileResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResult>><any>_observableThrow(response_);
        }));
    }

    protected processFilesDownloadGet(response: HttpResponseBase): Observable<FileResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileResult.fromJS(resultData200) : new FileResult();
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = resultData400 ? BadRequestResult.fromJS(resultData400) : new BadRequestResult();
            return throwException("A server error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResult>(<any>null);
    }

    /**
     * Saves transaction data
     * @param data (optional) transaction data in Json format
     * @return Success
     */
    dataTransactionsPost(data: string | null | undefined): Observable<NoContentResult> {
        let url_ = this.baseUrl + "/api/data/transactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataTransactionsPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataTransactionsPost(<any>response_);
                } catch (e) {
                    return <Observable<NoContentResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<NoContentResult>><any>_observableThrow(response_);
        }));
    }

    protected processDataTransactionsPost(response: HttpResponseBase): Observable<NoContentResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NoContentResult.fromJS(resultData200) : new NoContentResult();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoContentResult>(<any>null);
    }

    /**
     * @return Success
     */
    pingGet(): Observable<void> {
        let url_ = this.baseUrl + "/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPingGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPingGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPingGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    healthcheckGet(): Observable<void> {
        let url_ = this.baseUrl + "/healthcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealthcheckGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealthcheckGet(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processHealthcheckGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Gets list of available templates
     * @return Success
     */
    templatesGet(): Observable<FileTemplate[]> {
        let url_ = this.baseUrl + "/api/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplatesGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplatesGet(<any>response_);
                } catch (e) {
                    return <Observable<FileTemplate[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileTemplate[]>><any>_observableThrow(response_);
        }));
    }

    protected processTemplatesGet(response: HttpResponseBase): Observable<FileTemplate[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(FileTemplate.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileTemplate[]>(<any>null);
    }

    /**
     * Gets download token for template file
     * @return Success
     */
    templatesByTemplateNameGet(templateName: string): Observable<TokenResult> {
        let url_ = this.baseUrl + "/api/templates/{templateName}";
        if (templateName === undefined || templateName === null)
            throw new Error("The parameter 'templateName' must be defined.");
        url_ = url_.replace("{templateName}", encodeURIComponent("" + templateName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplatesByTemplateNameGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplatesByTemplateNameGet(<any>response_);
                } catch (e) {
                    return <Observable<TokenResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenResult>><any>_observableThrow(response_);
        }));
    }

    protected processTemplatesByTemplateNameGet(response: HttpResponseBase): Observable<TokenResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TokenResult.fromJS(resultData200) : new TokenResult();
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = resultData404 ? NotFoundResult.fromJS(resultData404) : new NotFoundResult();
            return throwException("A server error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenResult>(<any>null);
    }
}

export class MappingRequiredResponse implements IMappingRequiredResponse {
    isMappingRequired!: boolean | undefined;
    submissionId!: string | undefined;
    errorMessage!: string | undefined;
    headerMin!: number | undefined;
    headerMax!: number | undefined;

    constructor(data?: IMappingRequiredResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isMappingRequired = data["isMappingRequired"];
            this.submissionId = data["submissionId"];
            this.errorMessage = data["errorMessage"];
            this.headerMin = data["headerMin"];
            this.headerMax = data["headerMax"];
        }
    }

    static fromJS(data: any): MappingRequiredResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MappingRequiredResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMappingRequired"] = this.isMappingRequired;
        data["submissionId"] = this.submissionId;
        data["errorMessage"] = this.errorMessage;
        data["headerMin"] = this.headerMin;
        data["headerMax"] = this.headerMax;
        return data; 
    }
}

export interface IMappingRequiredResponse {
    isMappingRequired: boolean | undefined;
    submissionId: string | undefined;
    errorMessage: string | undefined;
    headerMin: number | undefined;
    headerMax: number | undefined;
}

export class BadRequestResult implements IBadRequestResult {
    statusCode!: number | undefined;

    constructor(data?: IBadRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
        }
    }

    static fromJS(data: any): BadRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        return data; 
    }
}

export interface IBadRequestResult {
    statusCode: number | undefined;
}

export class SubmissionMetadata implements ISubmissionMetadata {
    fileName!: string | undefined;
    size!: number | undefined;
    uploadedDate!: moment.Moment | undefined;
    fileExtension!: string | undefined;
    submissionId!: string | undefined;
    submitterId!: string | undefined;
    submitterName!: string | undefined;
    correlationId!: string | undefined;
    mappingNeeded!: boolean | undefined;
    storage!: IStoredObject | undefined;
    impersonatorUserId!: string | undefined;
    impersonatorTenantId!: string | undefined;

    constructor(data?: ISubmissionMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileName = data["fileName"];
            this.size = data["size"];
            this.uploadedDate = data["uploadedDate"] ? moment(data["uploadedDate"].toString()) : <any>undefined;
            this.fileExtension = data["fileExtension"];
            this.submissionId = data["submissionId"];
            this.submitterId = data["submitterId"];
            this.submitterName = data["submitterName"];
            this.correlationId = data["correlationId"];
            this.mappingNeeded = data["mappingNeeded"];
            this.storage = data["storage"] ? IStoredObject.fromJS(data["storage"]) : <any>undefined;
            this.impersonatorUserId = data["impersonatorUserId"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
        }
    }

    static fromJS(data: any): SubmissionMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["size"] = this.size;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>undefined;
        data["fileExtension"] = this.fileExtension;
        data["submissionId"] = this.submissionId;
        data["submitterId"] = this.submitterId;
        data["submitterName"] = this.submitterName;
        data["correlationId"] = this.correlationId;
        data["mappingNeeded"] = this.mappingNeeded;
        data["storage"] = this.storage ? this.storage.toJSON() : <any>undefined;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        return data; 
    }
}

export interface ISubmissionMetadata {
    fileName: string | undefined;
    size: number | undefined;
    uploadedDate: moment.Moment | undefined;
    fileExtension: string | undefined;
    submissionId: string | undefined;
    submitterId: string | undefined;
    submitterName: string | undefined;
    correlationId: string | undefined;
    mappingNeeded: boolean | undefined;
    storage: IStoredObject | undefined;
    impersonatorUserId: string | undefined;
    impersonatorTenantId: string | undefined;
}

/** Defines an object stored in an object store (e.g., Azure blob storage) */
export class IStoredObject implements IIStoredObject {
    originalFileName!: string | undefined;
    storedFileName!: string | undefined;
    storageType!: IStoredObjectStorageType | undefined;
    location!: string | undefined;

    constructor(data?: IIStoredObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.originalFileName = data["originalFileName"];
            this.storedFileName = data["storedFileName"];
            this.storageType = data["storageType"];
            this.location = data["location"];
        }
    }

    static fromJS(data: any): IStoredObject {
        data = typeof data === 'object' ? data : {};
        let result = new IStoredObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalFileName"] = this.originalFileName;
        data["storedFileName"] = this.storedFileName;
        data["storageType"] = this.storageType;
        data["location"] = this.location;
        return data; 
    }
}

/** Defines an object stored in an object store (e.g., Azure blob storage) */
export interface IIStoredObject {
    originalFileName: string | undefined;
    storedFileName: string | undefined;
    storageType: IStoredObjectStorageType | undefined;
    location: string | undefined;
}

export class MappingHeadersResponse implements IMappingHeadersResponse {
    sourceColumns!: string[] | undefined;
    targetColumns!: ColumnInfo[] | undefined;
    data!: string[] | undefined;
    mappings!: Mapping[] | undefined;
    errorMessage!: string | undefined;

    constructor(data?: IMappingHeadersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["sourceColumns"] && data["sourceColumns"].constructor === Array) {
                this.sourceColumns = [];
                for (let item of data["sourceColumns"])
                    this.sourceColumns.push(item);
            }
            if (data["targetColumns"] && data["targetColumns"].constructor === Array) {
                this.targetColumns = [];
                for (let item of data["targetColumns"])
                    this.targetColumns.push(ColumnInfo.fromJS(item));
            }
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [];
                for (let item of data["data"])
                    this.data.push(item);
            }
            if (data["mappings"] && data["mappings"].constructor === Array) {
                this.mappings = [];
                for (let item of data["mappings"])
                    this.mappings.push(Mapping.fromJS(item));
            }
            this.errorMessage = data["errorMessage"];
        }
    }

    static fromJS(data: any): MappingHeadersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MappingHeadersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.sourceColumns && this.sourceColumns.constructor === Array) {
            data["sourceColumns"] = [];
            for (let item of this.sourceColumns)
                data["sourceColumns"].push(item);
        }
        if (this.targetColumns && this.targetColumns.constructor === Array) {
            data["targetColumns"] = [];
            for (let item of this.targetColumns)
                data["targetColumns"].push(item.toJSON());
        }
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        if (this.mappings && this.mappings.constructor === Array) {
            data["mappings"] = [];
            for (let item of this.mappings)
                data["mappings"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        return data; 
    }
}

export interface IMappingHeadersResponse {
    sourceColumns: string[] | undefined;
    targetColumns: ColumnInfo[] | undefined;
    data: string[] | undefined;
    mappings: Mapping[] | undefined;
    errorMessage: string | undefined;
}

export class ColumnInfo implements IColumnInfo {
    name!: string | undefined;
    required!: boolean | undefined;

    constructor(data?: IColumnInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.required = data["required"];
        }
    }

    static fromJS(data: any): ColumnInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ColumnInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["required"] = this.required;
        return data; 
    }
}

export interface IColumnInfo {
    name: string | undefined;
    required: boolean | undefined;
}

export class Mapping implements IMapping {
    source!: string | undefined;
    target!: string | undefined;

    constructor(data?: IMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.source = data["source"];
            this.target = data["target"];
        }
    }

    static fromJS(data: any): Mapping {
        data = typeof data === 'object' ? data : {};
        let result = new Mapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["target"] = this.target;
        return data; 
    }
}

export interface IMapping {
    source: string | undefined;
    target: string | undefined;
}

export class NoContentResult implements INoContentResult {
    statusCode!: number | undefined;

    constructor(data?: INoContentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
        }
    }

    static fromJS(data: any): NoContentResult {
        data = typeof data === 'object' ? data : {};
        let result = new NoContentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        return data; 
    }
}

export interface INoContentResult {
    statusCode: number | undefined;
}

export class TokenResult implements ITokenResult {
    fileToken!: string | undefined;

    constructor(data?: ITokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fileToken = data["fileToken"];
        }
    }

    static fromJS(data: any): TokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        return data; 
    }
}

export interface ITokenResult {
    fileToken: string | undefined;
}

export class NotFoundResult implements INotFoundResult {
    statusCode!: number | undefined;

    constructor(data?: INotFoundResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusCode = data["statusCode"];
        }
    }

    static fromJS(data: any): NotFoundResult {
        data = typeof data === 'object' ? data : {};
        let result = new NotFoundResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        return data; 
    }
}

export interface INotFoundResult {
    statusCode: number | undefined;
}

export class ValidationSettings implements IValidationSettings {
    allowedExtensions!: string[] | undefined;
    manualProcessedExtensions!: string[] | undefined;

    constructor(data?: IValidationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["allowedExtensions"] && data["allowedExtensions"].constructor === Array) {
                this.allowedExtensions = [];
                for (let item of data["allowedExtensions"])
                    this.allowedExtensions.push(item);
            }
            if (data["manualProcessedExtensions"] && data["manualProcessedExtensions"].constructor === Array) {
                this.manualProcessedExtensions = [];
                for (let item of data["manualProcessedExtensions"])
                    this.manualProcessedExtensions.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.allowedExtensions && this.allowedExtensions.constructor === Array) {
            data["allowedExtensions"] = [];
            for (let item of this.allowedExtensions)
                data["allowedExtensions"].push(item);
        }
        if (this.manualProcessedExtensions && this.manualProcessedExtensions.constructor === Array) {
            data["manualProcessedExtensions"] = [];
            for (let item of this.manualProcessedExtensions)
                data["manualProcessedExtensions"].push(item);
        }
        return data; 
    }
}

export interface IValidationSettings {
    allowedExtensions: string[] | undefined;
    manualProcessedExtensions: string[] | undefined;
}

export class FileResult implements IFileResult {
    contentType!: string | undefined;
    fileDownloadName!: string | undefined;
    lastModified!: moment.Moment | undefined;
    entityTag!: EntityTagHeaderValue | undefined;

    constructor(data?: IFileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.fileDownloadName = data["fileDownloadName"];
            this.lastModified = data["lastModified"] ? moment(data["lastModified"].toString()) : <any>undefined;
            this.entityTag = data["entityTag"] ? EntityTagHeaderValue.fromJS(data["entityTag"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileResult {
        data = typeof data === 'object' ? data : {};
        let result = new FileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["fileDownloadName"] = this.fileDownloadName;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["entityTag"] = this.entityTag ? this.entityTag.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IFileResult {
    contentType: string | undefined;
    fileDownloadName: string | undefined;
    lastModified: moment.Moment | undefined;
    entityTag: EntityTagHeaderValue | undefined;
}

export class EntityTagHeaderValue implements IEntityTagHeaderValue {
    tag!: StringSegment | undefined;
    isWeak!: boolean | undefined;

    constructor(data?: IEntityTagHeaderValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tag = data["tag"] ? StringSegment.fromJS(data["tag"]) : <any>undefined;
            this.isWeak = data["isWeak"];
        }
    }

    static fromJS(data: any): EntityTagHeaderValue {
        data = typeof data === 'object' ? data : {};
        let result = new EntityTagHeaderValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["isWeak"] = this.isWeak;
        return data; 
    }
}

export interface IEntityTagHeaderValue {
    tag: StringSegment | undefined;
    isWeak: boolean | undefined;
}

export class StringSegment implements IStringSegment {
    buffer!: string | undefined;
    offset!: number | undefined;
    length!: number | undefined;
    value!: string | undefined;
    hasValue!: boolean | undefined;

    constructor(data?: IStringSegment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.buffer = data["buffer"];
            this.offset = data["offset"];
            this.length = data["length"];
            this.value = data["value"];
            this.hasValue = data["hasValue"];
        }
    }

    static fromJS(data: any): StringSegment {
        data = typeof data === 'object' ? data : {};
        let result = new StringSegment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buffer"] = this.buffer;
        data["offset"] = this.offset;
        data["length"] = this.length;
        data["value"] = this.value;
        data["hasValue"] = this.hasValue;
        return data; 
    }
}

export interface IStringSegment {
    buffer: string | undefined;
    offset: number | undefined;
    length: number | undefined;
    value: string | undefined;
    hasValue: boolean | undefined;
}

export class FileTemplate implements IFileTemplate {
    type!: string | undefined;
    fileName!: string | undefined;
    cultureName!: string | undefined;

    constructor(data?: IFileTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.type = data["type"];
            this.fileName = data["fileName"];
            this.cultureName = data["cultureName"];
        }
    }

    static fromJS(data: any): FileTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new FileTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["cultureName"] = this.cultureName;
        return data; 
    }
}

export interface IFileTemplate {
    type: string | undefined;
    fileName: string | undefined;
    cultureName: string | undefined;
}

export enum IStoredObjectStorageType {
    _0 = 0, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = function() { 
                observer.next(this.result);
                observer.complete();
            }
            reader.readAsText(blob); 
        }
    });
}
